class TsUpsellCard extends HTMLElement {
  constructor() {
    super();

    this.buyBtn = this.querySelector('button');
    this.variantId = this.querySelector('input[name="id"]').value;
    this.handleAddToCart = this.handleAddToCart.bind(this);
    this.upsellWrapper = document.querySelector('ts-upsell');
  }

  connectedCallback() {
    this.buyBtn.addEventListener('click', this.handleAddToCart);
  }

  async handleAddToCart() {
    if (!this.variantId) return;
    this.buyBtn.setAttribute('disabled', '');
    const formData = new FormData();
    formData.append('id', this.variantId);
    formData.append('quantity', 1);

    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        body: formData
      });

    if (!response.ok) throw new Error('Failed to add item');
      this.upsellWrapper.rerenderUpsell();
     const progressBar = document.querySelector('.progress-bar');

      if (progressBar) {
        progressBar.handleProgress();
      }
    } catch (error) {
      console.error('Error updating cart drawer:', error);
    }
  }

  disconnectedCallback() {
    this.buyBtn.removeEventListener('click', this.handleAddToCart);
  }
}

customElements.define('ts-upsell-card', TsUpsellCard);
